import { formatDateTime } from '@/lib/format'
import { messages } from '@/lib/messages'
import { periodLabel } from '@/lib/period'

const t = messages.documents.runs.print

/**
 * Antet (kopyanın ilk sayfası; ekranda da aynı görünür). Yer tutucudur: solda yazı ve altında
 * tam genişlikte ince çizgi, sağda rapor bilgisi. Gerçek antet (logo, unvan, imza) gelince yalnız
 * bu bileşen değişir (docs/REPORT-DOCUMENTS-PLAN.md §7.3).
 */
export function Letterhead({
  title,
  period,
  createdAt,
  refreshedAt,
}: {
  title: string
  /** `YYYY-MM` */
  period: string
  createdAt: string
  refreshedAt: string | null
}) {
  return (
    <header
      aria-label={t.letterhead}
      className="border-border mb-6 flex items-end justify-between gap-6 border-b pb-3"
    >
      <p className="text-base font-semibold">{t.letterhead}</p>
      <div className="flex flex-col items-end text-xs">
        <span className="font-medium">{title}</span>
        <span>{t.period(periodLabel(period))}</span>
        <span className="text-muted-foreground">{t.generatedAt(formatDateTime(createdAt))}</span>
        {refreshedAt && (
          <span className="text-muted-foreground">
            {t.refreshedAt(formatDateTime(refreshedAt))}
          </span>
        )}
      </div>
    </header>
  )
}

/** Her basılı sayfada (sabit konum) görünen çapraz "TASLAK" yazısı; yalnız `draft` kopyada. */
export function DraftWatermark() {
  return (
    <div
      aria-hidden="true"
      data-testid="draft-watermark"
      className="pointer-events-none fixed inset-0 z-10 flex items-center justify-center overflow-hidden select-none"
    >
      <span className="-rotate-45 text-9xl font-bold tracking-widest text-black/10">
        {t.watermark}
      </span>
    </div>
  )
}
